import script from "./PageRenderer.vue?vue&type=script&setup=true&lang=js"
export * from "./PageRenderer.vue?vue&type=script&setup=true&lang=js"

import "./PageRenderer.vue?vue&type=style&index=0&id=362c24f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-362c24f6"]])

export default __exports__